import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp, Edit2, Trash2, Plus } from "lucide-react";
import Select from "react-select";

/**
 * Set Reminder Section Component for AddAssets
 * Handles reminder management with Monthly/Yearly types
 */
const SetReminderSection = ({
  showReminderSection,
  setShowReminderSection,
  setFieldValue,
  values,
  reminderForm,
  setReminderForm,
  reminders,
  remindersCollapsed,
  setRemindersCollapsed,
  editingReminderId,
  handleAddReminder,
  handleEditReminder,
  handleDeleteReminder,
  handleCompleteReminder,
  getMonthName,
  userId,
  assetId,
  readOnly = false
}) => {
  const [showReminderForm, setShowReminderForm] = useState(!editingReminderId);

  useEffect(() => {
    setShowReminderForm(!!editingReminderId);
  }, [editingReminderId, reminders]);
  return (
    <div className="col-12 mb-4">
      <label className="form-label">Set Reminder</label>

      <div className="radio-group">
        <div className="form-check">
          <input
            type="radio"
            name="setReminder"
            value="yes"
            className="form-check-input"
            id="reminderYes"
            checked={values ? values.setReminder === "yes" : showReminderSection === "yes"}
            onChange={(e) => {
              if (setFieldValue) setFieldValue("setReminder", e.target.value);
              setShowReminderSection("yes");
            }}
            disabled={readOnly}
          />
          <label className="form-check-label" htmlFor="reminderYes">
            Yes
          </label>
        </div>
        <div className="form-check">
          <input
            type="radio"
            name="setReminder"
            value="no"
            className="form-check-input"
            id="reminderNo"
            checked={values ? values.setReminder === "no" : showReminderSection === "no"}
            onChange={(e) => {
              if (setFieldValue) setFieldValue("setReminder", e.target.value);
              setShowReminderSection("no");
            }}
            disabled={readOnly}
          />
          <label className="form-check-label" htmlFor="reminderNo">
            No
          </label>
        </div>
      </div>

      {showReminderSection === "yes" && (
        <div className="reminder-form-container mt-3">
          {(showReminderForm || (!assetId && reminders.length === 0) || (assetId && reminders.length === 0)) && (
            <div className="row">
              <div className="col-12 mb-3">
                <label className="form-label label-sm">Description*</label>
                <input
                  type="text"
                  className="form-control reminder-input"
                  placeholder="E.g. Insurance premium payment."
                  value={reminderForm.description}
                  onChange={(e) =>
                    setReminderForm({ ...reminderForm, description: e.target.value })
                  }
                  disabled={readOnly}
                />
              </div>
              <div
    className={`${
      reminderForm.type === "Monthly"
        ? "col-md-6"
        : reminderForm.type === "Weekly"
        ? ""
        : "col-md-4"
    } mb-3`}
  >

                <label className="form-label label-sm">Type*</label>
                <Select
                  options={[
                    { value: "Weekly", label: "Weekly" },
                    { value: "Monthly", label: "Monthly" },
                    { value: "Yearly", label: "Yearly" }
                  ]}
                  value={{ value: reminderForm.type, label: reminderForm.type }}
                  onChange={(selectedOption) =>
                    setReminderForm({ ...reminderForm, type: selectedOption.value })
                  }
                  placeholder="Select reminder type"
                  classNamePrefix="react-select"
                  isSearchable={false}
                  isDisabled={readOnly}
                />
              </div>

             {reminderForm.type === "Monthly" ? (
    // 🔹 MONTHLY
    <div className="col-md-6 mb-3">
      <label className="form-label label-sm">Day of Month</label>
      <Select
        options={[...Array(31)].map((_, i) => ({ value: i + 1, label: i + 1 }))}
        value={{ value: reminderForm.dayOfMonth, label: reminderForm.dayOfMonth }}
        onChange={(selectedOption) =>
          setReminderForm({
            ...reminderForm,
            dayOfMonth: selectedOption.value,
          })
        }
        classNamePrefix="react-select"
        isSearchable={false}
        isDisabled={readOnly}
        placeholder="Select day"
      />
    </div>
  ) : reminderForm.type === "Weekly" ? (

    null
  ) : (

    <>
      <div className="col-md-4 mb-3">
        <label className="form-label label-sm">Month of Year</label>
        <Select
          options={[...Array(12)].map((_, i) => ({ value: i + 1, label: getMonthName(i + 1) }))}
          value={{ value: reminderForm.monthOfYear, label: getMonthName(reminderForm.monthOfYear) }}
          onChange={(selectedOption) =>
            setReminderForm({
              ...reminderForm,
              monthOfYear: selectedOption.value,
            })
          }
          classNamePrefix="react-select"
          isSearchable={false}
          isDisabled={readOnly}
          placeholder="Select month"
        />
      </div>

      <div className="col-md-4 mb-3">
        <label className="form-label label-sm">Day of Month</label>
        <Select
          options={[...Array(31)].map((_, i) => ({ value: i + 1, label: i + 1 }))}
          value={{ value: reminderForm.dayOfMonth, label: reminderForm.dayOfMonth }}
          onChange={(selectedOption) =>
            setReminderForm({
              ...reminderForm,
              dayOfMonth: selectedOption.value,
            })
          }
          classNamePrefix="react-select"
          isSearchable={false}
          isDisabled={readOnly}
          placeholder="Select day"
        />
      </div>
    </>
)}


              {assetId && (
                <div className="col-md-12 d-flex align-items-end mb-3 gap-2">
                  <button
                    type="button"
                    className="btn btn-primary flex-grow-1"
                    onClick={handleAddReminder}
                    disabled={readOnly}
                  >
                    {editingReminderId ? "Update Reminder" : "Add Reminder"}
                  </button>
                  {reminders.length > 0 && (
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowReminderForm(false)}
                      disabled={readOnly}
                    >
                      Back
                    </button>
                  )}
                </div>
              )}
            </div>
          )}

          {reminders.length > 0 && !showReminderForm && (
            <div className="reminders-list-section mt-2">
              <div
                className="reminders-collapse-header d-flex justify-content-between align-items-center"
                onClick={() => setRemindersCollapsed(!remindersCollapsed)}
              >
                <label className="form-label">Reminders</label>
                <div className="d-flex align-items-center gap-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowReminderForm(true);
                    }}
                  >
                    <Plus size={14} />
                  </button>
                  {remindersCollapsed ? (
                    <ChevronDown size={18} />
                  ) : (
                    <ChevronUp size={18} />
                  )}
                </div>
              </div>

              {!remindersCollapsed && (
                <div className="reminders-items-container mt-2">
                  {reminders.map((reminder, idx) => (
                    <div
                      key={reminder.id}
                      className="d-flex align-items-center bg-white py-2 px-3 rounded-md mb-2 last:mb-0"
                    >
                      <div className="w-6 h-6 d-inline-flex justify-center items-center rounded-full bg-blue-100 font-semibold flex-shrink-0 text-sm">
                        {idx + 1}
                      </div>
                      <div className="flex-grow-1 ms-2 pr-1">
                        <div className="font-semibold text-sm">
                          {reminder.description}
                        </div>
                        <div className="font-medium text-xs text-muted">
                          {reminder.type === "Weekly" || reminder.type === "weekly"
                            ? "Weekly"
                            : reminder.type === "Monthly" || reminder.type === "monthly"
                            ? `Monthly - Day ${reminder.dayOfMonth}`
                            : `Yearly - ${getMonthName(reminder.monthOfYear)} ${reminder.dayOfMonth}`}
                        </div>
                      </div>
                      {!readOnly && (
                        <div className="reminder-actions d-flex gap-3">
                          <button
                            type="button"
                            className="text-muted"
                            onClick={() => handleEditReminder(reminder)}
                          >
                            <Edit2 size={14} />
                          </button>
                          <button
                            type="button"
                            className="text-danger"
                            onClick={() => handleDeleteReminder(reminder.id)}
                          >
                            <Trash2 size={14} />
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SetReminderSection;
